module.exports = __webpack_public_path__ + "img/ico_upload.e520f4b1.svg";